import { Link, useNavigate } from "react-router-dom"
import styled from "styled-components"
import { Button } from "~/components"
import { useTranslate } from "~/ur-react-hooks"
import { format } from "~/utils/date-fns/format"
import { useSubscriptionInfo } from "~/utils/hooks/useSubscriptionInfo"
import { trpc } from "~/utils/trpc"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  width: 456px;
  padding: 2rem 4rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  border-radius: 8px;
`

const Title = styled.h3`
  margin: 0;
  text-align: center;
`

const Subtitle = styled.p`
  margin: 0;
  text-align: center;
`
const BottomSection = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ConfirmCancelButton = styled.button`
  margin-top: 1rem;
  ${(props) => props.theme.button.reset}
  color: ${(props) => props.theme.colors.gray60};

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export type CancelSubscriptionProps = {}

const CancelSubscription: React.FC<CancelSubscriptionProps> = () => {
  const subscription = useSubscriptionInfo()
  const translations = useTranslate({
    title: "cancel-subscription.title",
    subtitle: ["cancel-subscription.subtitle", { date: "01-01-2021" }],
    keepSubscription: "cancel-subscription.keep-subscription",
    confirmCancel: "cancel-subscription.confirm-cancel",
    loading: "common.loading...",
  })

  const navigate = useNavigate()

  const trpcContext = trpc.useContext()

  const { mutate: cancelSubscription, isPending: isLoading } =
    trpc.subscriptions.cancelSubscription.useMutation({
      onSuccess() {
        navigate("/subscription/cancel-success")
        trpcContext.users.me.invalidate()
      },
    })

  if (!subscription) {
    navigate("/home")
    return null
  }

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Subtitle>
          {translations.subtitle({
            date: format(
              subscription?.nextPayment ?? new Date(),
              "dd. MMMM yyyy",
            ),
          })}
        </Subtitle>
        <BottomSection>
          <Link to="/home">
            <Button>{translations.keepSubscription}</Button>
          </Link>
          <ConfirmCancelButton
            disabled={isLoading}
            onClick={() =>
              cancelSubscription({ id: subscription.stripeSubscriptionId })
            }
          >
            {isLoading ? translations.loading : translations.confirmCancel}
          </ConfirmCancelButton>
        </BottomSection>
      </Card>
    </Layout>
  )
}

export default CancelSubscription
